import { ArrowUpRight } from "lucide-react";
import { PageShell, ShellSection } from "./PageShell";
import { StatusBadge } from "../components/common";
import { IDENTIFIERS, CAPABILITIES } from "../data/content";
import { Reveal } from "../components/Reveal";

export default function GovResearchPage() {
    return (
        <PageShell
            testId="government-research-page"
            overline="Government & Research"
            metaTitle="Government & Research — Titan Haven Group LLC"
            title="THGov and the research path."
            lede="Titan Haven Group maintains active government-facing activity and proposals, alongside a research and development initiative currently on the SBIR/STTR path."
        >
            <ShellSection>
                <Reveal className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                    <div>
                        <h2 className="font-display text-2xl md:text-3xl font-medium text-white">THGov</h2>
                        <p className="mt-4 text-sm md:text-base leading-relaxed text-thg-secondary">
                            Government-facing capability for public-sector and institutional initiatives. THG has
                            active government-facing activity and proposals in progress. Available work lanes:
                        </p>
                        <ul className="mt-6 space-y-3" data-testid="gov-capabilities">
                            {CAPABILITIES.map((c) => (
                                <li key={c} className="flex items-center gap-3 text-sm text-thg-secondary">
                                    <span className="block w-1.5 h-1.5 bg-thg-red shrink-0" aria-hidden="true" />
                                    {c}
                                </li>
                            ))}
                        </ul>
                        <p className="mt-6 text-xs leading-relaxed text-thg-tertiary">
                            Vendor registration and proposal activity are eligibility positions, not awards.
                        </p>
                        <p className="mt-4 text-xs leading-relaxed text-thg-tertiary" data-testid="gov-engagement-range">
                            Government and applied-research engagements are scoped by statement of work; typical
                            engagements start at $15,000. Final fees depend on scope, access, travel, data,
                            procurement, and implementation needs.
                        </p>
                    </div>
                    <div className="bg-thg-surface border border-thg-border p-8 md:p-10 h-fit">
                        <StatusBadge testId="gov-credential-badge">Credential</StatusBadge>
                        <h3 className="mt-4 font-display text-xl font-medium text-white">
                            Pennsylvania ITQ Approved Vendor
                        </h3>
                        <p className="mt-3 text-sm leading-relaxed text-thg-secondary">
                            Approved vendor — Management &amp; Government Operations Analysis.
                        </p>
                        <p className="mt-5 pt-5 border-t border-thg-border text-xs leading-relaxed text-thg-tertiary" data-testid="gov-identifiers">
                            {IDENTIFIERS.legalName} &middot; {IDENTIFIERS.structure}
                            <br />
                            SAM UEI: {IDENTIFIERS.samUei} &middot; CAGE: {IDENTIFIERS.cage}
                        </p>
                    </div>
                </Reveal>
            </ShellSection>
            <ShellSection>
                <Reveal className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                    <div>
                        <h2 className="font-display text-2xl md:text-3xl font-medium text-white">THLS AI</h2>
                        <p className="mt-4 text-sm md:text-base leading-relaxed text-thg-secondary">
                            A workplace communication readiness platform under active SBIR/STTR development.
                            THLS AI is a research and development initiative — not yet a commercial product.
                        </p>
                        <div className="mt-5">
                            <StatusBadge>Active Development</StatusBadge>
                        </div>
                    </div>
                    <div>
                        <h2 className="font-display text-2xl md:text-3xl font-medium text-white">Published research</h2>
                        <p className="mt-4 text-sm md:text-base leading-relaxed text-thg-secondary">
                            The Operational Intelligence Brief — ongoing research published through WarRoom
                            Solutions.
                        </p>
                        <a
                            href="https://warroomlabs.substack.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="gov-research-link"
                            className="mt-6 inline-flex items-center gap-2 text-sm text-thg-secondary hover:text-white transition-colors duration-300"
                        >
                            Read the research <ArrowUpRight size={15} />
                        </a>
                    </div>
                </Reveal>
            </ShellSection>
        </PageShell>
    );
}
